module.exports = __webpack_public_path__ + "static/media/mock-hoc.cb216121.png";